import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import app from "../components/app/reducer";
import auth from "../components/Auth/reducer";
import user from "../components/User/reducer";
import invites from "../components/Invites/reducer";
import approvals from "../components/User/ApprovalsTable/reducer";
import settings from "../components/settings/reducer";
import featureSettings from "../components/FeatureSettings/reducer"
import security from "../components/security/reducer";
import scenarios from "components/Scenarios/reducer";
import central_arizona from "../components/CentralArizona/reducer";
import technical_view from "../components/TechnicalView/reducer";
// import public_view from "../components/PublicView/reducer";
import arizona from "../components/Arizona/reducer";
import water_user from "../components/WaterUser/WaterUserVisualization/common/reducer";

export default (history) => {
  const rootReducer = combineReducers({
    app,
    auth,
    user,
    approvals,
    invites,
    settings,
    featureSettings,
    security,
    scenarios,
    central_arizona,
    technical_view,
    // public_view,
    arizona,
    water_user,
    router: connectRouter(history),
  });

  return (state = {}, action) => {
    if (!action) return state;

    // use the regular reducer
    return rootReducer(state, action);
  };
};
